import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconIndustry = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.01 39.99",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:currentColor;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "Asset 2" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			"data-name": "Layer 2",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Layer_1-2",
				"data-name": "Layer 1",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M2,0A2,2,0,0,0,0,2V38.56a1.37,1.37,0,0,0,.42,1,1.37,1.37,0,0,0,1,.42H38.58A1.45,1.45,0,0,0,40,38.56V12.84a1.43,1.43,0,0,0-2.32-1.12l-12,9.58V12.84a1.43,1.43,0,0,0-2.32-1.12L11,21V2A2,2,0,0,0,9,0Z"
				})
			})
		})
	]
});
export default SvgIconIndustry;
